"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Config_1 = require("../Config/Config");
const FetchProxy_1 = require("../Utility/FetchProxy");
class PaymentService {
    async paymentGetHistory(paymentId) {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/payment/history/get?paymentId=${paymentId}`).auth().fetch();
            return await res.json();
        }
        catch (err) {
            throw new Error(`Failed to get payment history: status ${err.message}`);
        }
    }
    async paymentCustom(paymentId) {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/payment/custom?paymentId=${paymentId}`).auth().fetch();
            return await res.json();
        }
        catch (err) {
            throw new Error(`Failed to get custom payment: status ${err.message}`);
        }
    }
}
exports.default = PaymentService;
//# sourceMappingURL=PaymentService.js.map